import React from "react";
import { Col } from "react-bootstrap";

export const Container = ({ referer, navigate, children }) => {
  return (
    <Col
      className="bg-light vh-100 p-4"
      style={{
        maxHeight: "calc(100% - 50px)",
        overflowY: "scroll",
      }}
    >
      {children}
    </Col>
  );
};
